export const getPagedUrns = (urns = [], urnCache = []) => urns.filter((urn) => !urnCache.includes(urn));
//# sourceMappingURL=get-paged-urns.js.map